import React, { FC } from "react"
import { Icon, IconProps } from "./Icon"

export const IconEyeOpened: FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M27.448 15.387c.33.348.33.878 0 1.226C25.916 18.233 21.37 22.5 16 22.5s-9.916-4.267-11.448-5.887a.884.884 0 010-1.226C6.084 13.767 10.63 9.5 16 9.5s9.916 4.267 11.448 5.887z"
      ></path>
      <circle cx="16" cy="16" r="3.25" stroke="#fff" strokeWidth="1.5"></circle>
    </Icon>
  )
}

export default IconEyeOpened
